var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiTwoThirds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    className: "bi bi-wifi-2",
    viewBox: "0 0 16 16",
    id: "Wifi-2--Streamline-Bootstrap",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wifi 2 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.229 8.271c0.216 -0.216 0.194 -0.578 -0.063 -0.745A9.46 9.46 0 0 0 8 6c-1.905 0 -3.68 0.56 -5.166 1.526a0.48 0.48 0 0 0 -0.063 0.745 0.525 0.525 0 0 0 0.652 0.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.577 1.336c0.205 0.132 0.48 0.108 0.652 -0.065m-2.183 2.183c0.226 -0.226 0.185 -0.605 -0.1 -0.75A6.5 6.5 0 0 0 8 9c-1.06 0 -2.062 0.254 -2.946 0.704 -0.285 0.145 -0.326 0.524 -0.1 0.75l0.015 0.015c0.16 0.16 0.408 0.19 0.611 0.09A5.5 5.5 0 0 1 8 10c0.868 0 1.69 0.201 2.42 0.56 0.203 0.1 0.45 0.07 0.611 -0.091zM9.06 12.44c0.196 -0.196 0.198 -0.52 -0.04 -0.66A2 2 0 0 0 8 11.5a2 2 0 0 0 -1.02 0.28c-0.238 0.14 -0.236 0.464 -0.04 0.66l0.706 0.706a0.5 0.5 0 0 0 0.708 0l0.707 -0.707z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiTwoThirds);
export default __webpack_public_path__ + "static/media/Wifi-Two-Thirds.20ca1930b5f05174881cf4dfba9608c6.svg";
export { ForwardRef as ReactComponent };